import React, {useState} from 'react'
import unlinked_expenses from '../assets/unlinked_expenses.svg'
import DragExpenses from './DragExpenses'
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';
function UnlinkedSection({expenses,sumExpenses,}) {
  const [width, setWidth] = useState(430); // Initial width
  const [height, setHeight] = useState(450);
  const handleResize = (event, { size }) => {
    setWidth(size.width);
    setHeight(size.height);
  };
  return (
    <><div className='tool-drag-tool' style={{minWidth: width}} >
    <Resizable
      width={width}
      height={height}
      onResize={handleResize}
      minConstraints={[350, 350]} // Optional: minimum width and height
      maxConstraints={[600, 500]} // Optional: maximum width and height
    >

        <div className='tool-expense-container' style={{width: width, height: height, position: 'fixed'}} >
          <div className='tool-expense-container-header'>
            <p className='unlinked-expenses'>
              <img src={unlinked_expenses} alt="unlinked" className="unlinked" />
            &nbsp;
            <span>Unlinked Expenses</span>
            </p>
            &nbsp; &nbsp;
            <span className='unlinked-expenses-value' >
              {Math.round(sumExpenses).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              &nbsp;
            </span>
          </div>
          <div className='tool-expense-container-body' style={{height: height - 68}}>
            <div className='unlinked-expenses-list' style={{height: height - 68}} >
              <div className='unlinked-listed'>
                <DragExpenses expenses={expenses} truncate={true} droppableID={'Unlinked'}/>
              </div>
             
            </div>
          </div>
        </div>

 
    </Resizable>
          </div>
    </>
   
  )
}

export default UnlinkedSection